import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { CgSpinner } from 'react-icons/cg';

import * as c from './constants';

function IconButton({
  type,
  icon,
  radius,
  size,
  onClick,
  disabled,
  className,
  to,
  withHiddenLabel,
  isLoading,
}) {
  const $type = disabled ? c.dispatchType?.disabled : c.dispatchType?.[type];
  const $radius = c.dispatchRadius?.[radius];
  const $size = c.dispatchSize?.[size];

  const style = {
    background: $type?.background,
    text: $type?.text,
    border: $type?.border,
    radius: $radius,
    size: $size,
  };

  const renderButton = () => (
    <>
      {withHiddenLabel && <div className="ds-form-label opacity-0">RO</div>}

      <button
        type="button"
        className={cn(
          'duration-150 ease-in-out transition-all flex items-center justify-center text-left focus:ring-2 focus:ring-default',
          style.background,
          style.text,
          style.radius,
          style.border,
          style.size,
          className
        )}
        onClick={onClick}
        disabled={disabled}
      >
        {isLoading ? (
          <button
            className={cn(
              'duration-150 ease-in-out transition-all flex items-center justify-center text-left absolute top-0 left-0',
              style.text,
              style.radius,
              style.border,
              style.size,
              className,
              '!p-0',
              {
                'cursor-not-allowed': isLoading,
              }
            )}
            style={{ inset: 'auto' }}
            type="button"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <CgSpinner className="h-5 w-5 animate-spin m-auto" />
          </button>
        ) : null}

        {typeof icon === 'function'
          ? icon({ className: 'h-ds-16 w-ds-16' })
          : icon}
      </button>
    </>
  );

  if (to) {
    return (
      <div>
        <Link to={to}>{renderButton()}</Link>
      </div>
    );
  }

  return <div>{renderButton()}</div>;
}

IconButton.defaultProps = {
  type: 'default',
  radius: 'default',
  icon: false,
  disabled: false,
  withHiddenLabel: false,
  size: 'default',
  onClick: () => {},
  className: '',
  to: '',
  isLoading: false,
};

IconButton.propTypes = {
  type: PropTypes.oneOf(
    Object.keys(c.dispatchType)?.filter((item) => item !== 'disabled')
  ),
  size: PropTypes.oneOf(Object.keys(c.dispatchSize)),
  radius: PropTypes.oneOf(Object.keys(c.dispatchRadius)),
  onClick: PropTypes.instanceOf(Function),
  disabled: PropTypes.bool,
  withHiddenLabel: PropTypes.bool,
  to: PropTypes.string,
  icon: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.element,
    PropTypes.string,
    PropTypes.instanceOf(Object),
    PropTypes.instanceOf(Function),
  ]),
  className: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default IconButton;
